
import React, { useEffect } from "react";

const PopUpLucky7secResults = ({ resultsData, catMid, marketType }) => {

    const resultData = resultsData; 

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const winners =
        resultData?.resultTxt
            ?.split(",")
            .map(item => item.trim())
            .filter(Boolean) || [];


    return (
        <div>
            <div id="ResultsData">
                <div className="left-content site_family">
                    <div id="lucky7Second" style={{ display: marketType == 26 ? "" : "none" }} >
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time ={" "}
                                    {formatMarketStartTime(dataObj?.evt_od)}
                                </div>

                                <div className="card-body">
                                    <div className="player-item" style={{ textAlign: "center" }}>
                                        <b>
                                            <span className="name" style={{ color: "#000" }}>Community Card</span>
                                        </b>
                                        <div className="player-card" style={{ display: "flex", justifyContent: "center" }}>
                                            <div className="BFBCardHandViewDealerab" style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                                <div className="BFBCardFanViewab" style={{ display: "flex", justifyContent: "center", padding: "1px" }}>

                                                    <div className="RSMImageView2ab">
                                                        <img src={`/assets/images/cards/${resultData.c1}.svg`}
                                                            class="img" style={{ width: "100%", maxWidth: "45px", height: "auto" }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                Low Card
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("Low Card") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                High Card
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("High Card") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                Even
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("Even") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                Odd
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("Odd") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                Red
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("Red") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                Black
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("Black") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                Spades
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("Spades") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                Hearts
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("Hearts") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                Clubs
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("Clubs") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                Diamonds
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("Diamonds") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                A23
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("A23") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                456
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("456") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                8910
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("8910") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                JQK
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("JQK") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                A
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("A") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">

                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                2
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("2") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                3
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("3") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                4
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("4") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                5
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("5") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                6
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("6") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                7
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("7") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                8
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("8") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                9
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("9") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                10
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("10") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                J
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("J") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                Q
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("Q") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="market-runners">
                                            <div className="runner-runner">
                                                <h3 className="runner-name">
                                                    <div className="runner-info">
                                                        <span className="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                className="clippable-spacer"
                                                            >
                                                                K
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div className="runner-disabled">
                                                    {winners.includes("K") ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopUpLucky7secResults;

